import type { TextAreaProps as TextAreaPropsAnt } from 'antd/lib/input';
import { Input as AntInput } from 'antd';
import type { VFC } from 'react';

export type TextAreaProps = Pick<
  TextAreaPropsAnt,
  | 'allowClear'
  | 'autoSize'
  | 'disabled'
  | 'id'
  | 'maxLength'
  | 'minLength'
  | 'name'
  | 'onChange'
  | 'onSubmit'
  | 'placeholder'
  | 'readOnly'
  | 'required'
  | 'rows'
  | 'showCount'
  | 'status'
  | 'style'
  | 'title'
  | 'value'
>;

export const TextArea: VFC<TextAreaProps> = props => {
  return <AntInput.TextArea {...props} />;
};
